import React from "react";
import { useNavigate } from "react-router-dom";
import "./CBRNButtons.css";

export default function CBRNButtons() {
  const navigate = useNavigate();

  return (
    <div className="cbrn-letters">
      <button className="cbrn-letter" onClick={() => navigate("/chemical")}>
        C
      </button>
      <button className="cbrn-letter" onClick={() => navigate("/biological")}>
        B
      </button>
      <button className="cbrn-letter" onClick={() => navigate("/radiationnuclear")}>
        RN
      </button>
    </div>
  );
}
